import { createFileRoute } from "@tanstack/react-router";
import AdminStatistikk from "../../../../pages/AdminStatistikk";

export const Route = createFileRoute("/_app/account/admin/")({
	component: AdminStatistikk,
});
